import { render, staticRenderFns } from "./OutpatientReviewDialog.vue?vue&type=template&id=1de56b41&"
import script from "./OutpatientReviewDialog.vue?vue&type=script&lang=js&"
export * from "./OutpatientReviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./OutpatientReviewDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports